import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { status_colors } from "../../services/shipping";
import { StatusColorsKeys } from "../../services/shipping";
import ShippingSummaryColorStatus from "./ShippingSummaryColorStatus";

interface ShippingSummaryStatusAlertProps {
  status: StatusColorsKeys;
}

const ShippingSummaryStatusAlert: React.FC<ShippingSummaryStatusAlertProps> = ({
  status,
}) => {
  const theme = useTheme();
  const color =
    status_colors[status as StatusColorsKeys] || theme.palette.grey[500];

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        justifyContent: "start",
        width: "100%",
      }}
    >
      <ShippingSummaryColorStatus color={color} />
      {status}
    </Box>
  );
};

export default ShippingSummaryStatusAlert;
